import { Stack, TextField } from '@mui/material';
import { useState, useRef, FormEvent } from 'react';
import CustomButton from '../../components/button/CustomButton';

interface ChatInputProps {
  onSendMessage: (message: string) => void | Promise<void>;
  disabled?: boolean;
  maxRows?: number;
  buttonHeight?: string;
  buttonMinWidth?: string;
  gap?: number;
  fontSize?: string;
}

export const ChatInput = ({
  onSendMessage,
  disabled = false,
  maxRows = 4,
  buttonHeight = '56px',
  buttonMinWidth = '100px',
  gap = 2,
  fontSize = '16px',
}: ChatInputProps) => {
  const [inputMessage, setInputMessage] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!inputMessage.trim() || disabled) return;

    const message = inputMessage;
    setInputMessage('');
    await onSendMessage(message);

    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Stack direction="row" gap={gap} alignItems="flex-end">
        <TextField
          fullWidth
          multiline
          maxRows={maxRows}
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          placeholder={'Type your message...'}
          disabled={disabled}
          inputProps={{ ref: inputRef }}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: fontSize,
            },
          }}
        />
        <CustomButton
          type="submit"
          disabled={!inputMessage.trim() || disabled}
          sx={{
            height: buttonHeight,
            minWidth: buttonMinWidth,
          }}
        >
          Send
        </CustomButton>
      </Stack>
    </form>
  );
};
